import { render, staticRenderFns } from "./IntelligentControlDyw.vue?vue&type=template&id=bdf4952c&scoped=true"
import script from "./IntelligentControlDyw.vue?vue&type=script&lang=js"
export * from "./IntelligentControlDyw.vue?vue&type=script&lang=js"
import style0 from "./IntelligentControlDyw.vue?vue&type=style&index=0&id=bdf4952c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf4952c",
  null
  
)

export default component.exports